export const hasReachedScrollEnd = (event: React.UIEvent): boolean => {
  const target = event.currentTarget;
  // use Math.abs approach to take into account complications such as zoom
  return Math.abs(target.scrollHeight - (target.scrollTop + target.clientHeight)) <= 1;
};
